var InsuranceType = /* @__PURE__ */ ((InsuranceType2) => {
  InsuranceType2["PRIVATE_INSURANCE"] = "PRIVATE_INSURANCE";
  InsuranceType2["SOCIAL_INSURANCE"] = "SOCIAL_INSURANCE";
  InsuranceType2["ADDITIONAL_PRIVATE_INSURANCE"] = "ADDITIONAL_PRIVATE_INSURANCE";
  return InsuranceType2;
})(InsuranceType || {});
var GenderType = /* @__PURE__ */ ((GenderType2) => {
  GenderType2["FEMALE"] = "FEMALE";
  GenderType2["MALE"] = "MALE";
  GenderType2["DIVERSE"] = "DIVERSE";
  return GenderType2;
})(GenderType || {});
var AppointmentCancellation = /* @__PURE__ */ ((AppointmentCancellation2) => {
  AppointmentCancellation2["NO_SHOW"] = "NO_SHOW";
  AppointmentCancellation2["CANCELED_ON_TIME"] = "CANCELED_ON_TIME";
  AppointmentCancellation2["CANCELED_SHORT_TERM"] = "CANCELED_SHORT_TERM";
  AppointmentCancellation2["CANCELED"] = "CANCELED";
  AppointmentCancellation2["CANCELED_MOVED"] = "CANCELED_MOVED";
  AppointmentCancellation2["OTHER"] = "OTHER";
  AppointmentCancellation2["CANCELED_BY_PRACTICE"] = "CANCELED_BY_PRACTICE";
  return AppointmentCancellation2;
})(AppointmentCancellation || {});
var AppointmentState = /* @__PURE__ */ ((AppointmentState2) => {
  AppointmentState2["OPEN"] = "OPEN";
  AppointmentState2["WAITING"] = "WAITING";
  AppointmentState2["IN_TREATMENT_ROOM"] = "IN_TREATMENT_ROOM";
  AppointmentState2["IN_TREATMENT"] = "IN_TREATMENT";
  AppointmentState2["TREATED"] = "TREATED";
  AppointmentState2["CANCELED"] = "CANCELED";
  AppointmentState2["CONTROLLED"] = "CONTROLLED";
  AppointmentState2["DELETED"] = "DELETED";
  AppointmentState2["NO_SHOW"] = "NO_SHOW";
  return AppointmentState2;
})(AppointmentState || {});
export {
  AppointmentCancellation,
  AppointmentState,
  GenderType,
  InsuranceType
};
